import { useOutletContext } from 'react-router-dom'
import type { Agent } from '@/types'
import { Card } from '@/components/ui/Card'
import { Badge } from '@/components/ui/Badge'

export function AgentOverviewTab() {
  const { agent } = useOutletContext<{ agent: Agent }>()

  return (
    <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: 16 }}>
      <Card>
        <div style={{ fontSize: 12, color: 'var(--text-secondary)', marginBottom: 4 }}>Descripción</div>
        <p style={{ fontSize: 14, marginBottom: 20 }}>{agent.description ?? '—'}</p>

        <div style={{ fontSize: 12, color: 'var(--text-secondary)', marginBottom: 4 }}>Stack técnico</div>
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
          {(agent.tech_stack ?? []).map((t) => <Badge key={t}>{t}</Badge>)}
        </div>
      </Card>

      <Card>
        <Field label="Owner" value={agent.owner ?? '—'} />
        <Field label="Canal" value={agent.channel ?? '—'} />
        <Field label="Modelo" value={agent.model ?? '—'} mono />
        <Field label="Presupuesto/mes" value={agent.monthly_budget_usd ? `$${agent.monthly_budget_usd}` : '—'} mono />
        <Field label="Versión de prompt" value={agent.prompt_version != null ? `v${agent.prompt_version}` : '—'} mono />
      </Card>
    </div>
  )
}

function Field({ label, value, mono }: { label: string; value: string; mono?: boolean }) {
  return (
    <div style={{ marginBottom: 14 }}>
      <div style={{ fontSize: 11, color: 'var(--text-tertiary)', marginBottom: 2 }}>{label}</div>
      <div className={mono ? 'mono' : undefined} style={{ fontSize: 14 }}>{value}</div>
    </div>
  )
}
